import * as React from 'react';
import { Alert, Box, Button, CircularProgress, FormControl, FormLabel, Grid, Input, Link, Modal, ModalDialog, Option, Select, Stack, Table, Typography } from "@mui/joy";
import { useDispatch, useSelector } from "react-redux";
import { resetarAgendamentosForm, triggerAgendarScript, triggerCarregaScriptAgendamentos, triggerRemoverAgendamento, updateAgendamentosAtributo, updateAgendamentosFormAtributo } from '../ScriptManagerSlice';
import { novaConfirmacao, startConfirmacao } from '../../helper/confirmation-modal/confirmationSlice';
import { displayGeneralDetail } from '../../helper/general-details/GeneralDetailSlice';

function ModalAgendar() {

    var dispatch = useDispatch()
    var form = useSelector((state) => state.scripts.agendamentos.form)
    var isOpen = form.isOpen

    var erro = form.erro
    var processando = form.processando
    var periodicidade = form.periodicidade
    var agendamentos = useSelector((state) => state.scripts.agendamentos.lista)

    var close = () => {
        dispatch(updateAgendamentosFormAtributo({
            campo: "isOpen",
            value: false
        }))
    }
    var salvar = () => {
        dispatch(triggerAgendarScript());
    }
    var ehEdicao = false
    var scripts = useSelector((state) => state.scripts.lista)

    var updateAttribute = (campo, valor) => {

        // console.log(campo, valor)

        dispatch(updateAgendamentosFormAtributo({
            campo: campo,
            value: valor
        }))

    }

    var updateScript = (e, scriptId) => {
        dispatch(updateAgendamentosFormAtributo({
            campo: "scriptId",
            value: scriptId
        }))

        var ag = agendamentos.filter(a => a.scriptId == scriptId)[0]

        if (typeof (ag) !== "undefined") {
            dispatch(updateAgendamentosFormAtributo({
                campo: "periodicidade",
                value: ag.periodicidade
            }))
        } else {
            dispatch(updateAgendamentosFormAtributo({
                campo: "periodicidade",
                value: ""
            }))
        }

    }

    function ErroDisplay(props) {
        if (props.erro == null || props.erro.length == 0) {
            return ""
        }

        return <Alert variant={"soft"} color="danger">
            {props.erro}
        </Alert>
    }

    return <Modal open={isOpen} onClose={close}>
        <ModalDialog
            aria-labelledby="basic-modal-dialog-title"
            aria-describedby="basic-modal-dialog-description"
            sx={{ width: 500 }}
        >
            <Typography id="basic-modal-dialog-title" component="h2">
                {ehEdicao ? "----- edicao" : "Agendamento"}
            </Typography>
            <Stack spacing={2}>
                <ErroDisplay erro={erro} />
                <Select onChange={updateScript}>
                    {scripts
                        .filter(e => e.dataCancelamento == null)
                        .map(e => <Option key={e.id} value={e.id}>{e.nome}</Option>)}
                </Select>
                <Typography>
                    <b>Periodicidade: </b> nM, nH ou nD, onde n inteiro
                </Typography>
                <Input placeholder="Periodicidade..." type="text" value={periodicidade} autoFocus disabled={processando} onChange={(e) => updateAttribute("periodicidade", e.target.value)}></Input>
                {/* <Checkbox onChange={() => updateValue("default", !dfault)} label="Lista padrao" ></Checkbox> */}
                <Box sx={{
                    textAlign: "right"
                }}>
                    <Button onClick={salvar} disabled={processando}>{
                        processando ? "Agendando..." : "Agendar"
                    }</Button>
                </Box>
            </Stack>
        </ModalDialog>
    </Modal>
}

function ScriptAgendamentoManager() {

    var dispatch = useDispatch()
    var st = useSelector((state) => state.scripts.agendamentos)
    var carregando = st.carregando
    var lista = st.lista

    var agendar = () => {
        dispatch(resetarAgendamentosForm());
        dispatch(updateAgendamentosFormAtributo({
            campo: "isOpen",
            value: true
        }));
    }

    var remover = (scriptId) => {
        dispatch(triggerRemoverAgendamento(scriptId))
    }

    React.useEffect(() => {
        dispatch(triggerCarregaScriptAgendamentos())
    }, []);

    if (carregando)
        return <Grid container sx={{ padding: "10px" }}>
            <Box sx={{ display: "flex", flexDirection: "row" }}>
                <Stack direction={"row"} spacing={2}>
                    <Typography>
                        Carregando
                    </Typography>
                    <CircularProgress size="sm" />
                </Stack>
            </Box>
        </Grid>

    return <Grid container sx={{ padding: "10px" }}>
        <ModalAgendar />
        <Stack spacing={2}>
            <Typography>
                Agendamentos
            </Typography>
            <Box>
                <Button color="primary" onClick={agendar}>
                    Agendar
                </Button>
            </Box>
            <Table size="small" aria-label="striped table" stripe={"even"}>
                <thead>
                    <tr>
                        <th style={{ width: "7%" }}>ScriptId</th>
                        <th style={{ width: "12%" }}>Periodicidade</th>
                        <th>Nome</th>
                        <th style={{ width: "7%" }}>Remover</th>
                    </tr>
                </thead>
                <tbody>
                    {
                        lista.map(l => {
                            return <tr key={l.id}>
                                <td>
                                    <Link onClick={() => dispatch(displayGeneralDetail(l.scriptId))
                                    }>{"ID"}</Link>
                                </td>
                                <td>
                                    {l.periodicidade}
                                </td>
                                <td>
                                    {l.nome}
                                </td>
                                <td>
                                    <Link onClick={() =>
                                        dispatch(startConfirmacao(novaConfirmacao("Deseja remover esse agendamento?", () => remover(l.scriptId))))
                                    }>[ x ]</Link>
                                </td>
                            </tr>
                        })
                    }
                </tbody>
            </Table>
        </Stack>
    </Grid>
}

export default ScriptAgendamentoManager;